module.exports = __webpack_public_path__ + "static/media/251570_screenshots_20181201142531_1.c1c658c4.jpg";